export enum CartStatusEnum {
  Initiated = 'initiated',
  Abandoned = 'abandoned',
  Collected = 'collected',
  Conflicted = 'conflicted',
  Accepted = 'accepted',
  Closed = 'closed' // ??????
}
